import React from "react";
import { Link } from "@/components/LocaleLink";
import { MessagesSquare, FileSearch, Phone } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { getIndsatser } from "@/data/indsatser";
import { CONTACT } from "@/i18n/translations";
import { trackEvent, EVENTS } from "@/lib/analytics";

const IndsatsCTA = ({ dark = false, slug }) => {
  const { lang } = useLang();
  const c = getIndsatser(lang).cta;
  const forloeb = slug || "usikker";

  const items = [
    { key: "discuss", label: c.discuss, Icon: MessagesSquare, event: EVENTS.CTA_DISCUSS },
    { key: "assessment", label: c.assessment, Icon: FileSearch, event: EVENTS.CTA_ASSESSMENT },
  ];

  return (
    <section className={dark ? "bg-[#1A2E24] text-white" : "bg-[#EAE5D9]"} data-testid="indsats-cta">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-16 lg:py-20 text-center">
        <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl leading-tight ${dark ? "text-white" : "text-[#1A2E24]"}`}>
          {c.title}
        </h2>
        <p className={`mt-4 text-lg max-w-2xl mx-auto ${dark ? "text-[#EAE5D9]" : "text-[#3B5245]"}`}>{c.subtitle}</p>
        <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
          {items.map((it) => {
            const Icon = it.Icon;
            return (
              <Link
                key={it.key}
                to={`/kontakt?forloeb=${forloeb}`}
                onClick={() => trackEvent(it.event, { forloeb })}
                className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#2D5A3F] text-white px-6 py-3.5 font-medium hover:bg-[#244a34] transition-colors duration-300"
                data-testid={`cta-${it.key}`}
              >
                <Icon className="h-4 w-4" /> {it.label}
              </Link>
            );
          })}
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            className={`inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 font-medium border transition-colors duration-300 ${
              dark ? "border-white/40 text-white hover:bg-white/10" : "border-[#2D5A3F] text-[#2D5A3F] hover:bg-[#2D5A3F] hover:text-white"
            }`}
            data-testid="cta-phone-indsats"
          >
            <Phone className="h-4 w-4" /> {c.contact}
          </a>
        </div>
      </div>
    </section>
  );
};

export default IndsatsCTA;
